<template>
  <common-dialog
    :value="getContractDialog.visible"
    @close="handleClose"
    width="1200px"
    title="小鼠购销合同"
    :closeOnClickModal="true"
    :fixed="true"
    blank-fill="small"
  >
    <template #body>
      <pdf-preview
        :download-url="getContractDialog.url"
        :split-line="true"
        width="100%"
      ></pdf-preview>
    </template>

    <template #footer>
      <div class="custom-footer">
        <div class="agree-bar" v-if="getContractDialog.type === 'sign'">
          <custom-check-box
            v-model="checked"
            label="本人已仔细阅读以上协议，知晓风险并同意签署本协议。"
          />
        </div>

        <el-button
          href="javascript:;"
          @click="handleCancel"
          class="btn cancel-btn"
          >{{
            (getContractDialog.type === "sign" && "我拒绝") ||
              (getContractDialog.type === "view" && "取消")
          }}</el-button
        >
        <el-button
          type="primary"
          :loading="loading"
          @click="handleSubmit"
          class="btn confirm-btn"
          :class="{ disabled: countdown }"
          v-if="getContractDialog.type === 'sign'"
        >
          我同意<template v-if="countdown">（{{ countdown }}）</template>
        </el-button>
      </div>
    </template>
  </common-dialog>
</template>
<script>
import CommonDialog from "@/components/CommonDialog";
import PdfPreview from "@/views/ProductDetails/pdfPreview.vue";
import CustomCheckBox from "@/components/CustomCheckBox";
import { Message } from "element-ui";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "contract-agreement-dialog",
  components: {
    CommonDialog,
    PdfPreview,
    CustomCheckBox
  },

  data() {
    return {
      countdown: 10,
      timer: null,
      loading: false,
      checked: false
    };
  },

  computed: {
    ...mapGetters("order", ["getContractDialog"])
  },

  watch: {
    getContractDialog: {
      handler(val) {
        if (val.visible) {
          if (val.type === "sign") {
            this.startCountdown();
            this.checked = false
          }
        } else {
          clearInterval(this.timer);
          this.countdown = 10;
        }
        this.loading = false;
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    ...mapMutations("order", ["setContractDialog"]),
    ...mapActions("order", ["requestWriteContract"]),
    handleClose() {
      this.setContractDialog({
        visible: false
      });
    },

    handleCancel() {
      if (this.getContractDialog.type === "sign") {
        this.$msgbox({
          title: "提示",
          message: "您不同意本协议约定，本订单即将取消，请确认",
          showCancelButton: true,
          cancelButtonText: "取消",
          confirmButtonText: "确认取消",
          closeOnClickModal: false,
          beforeClose: async (action, instance, done) => {
            if (action === "confirm" && this.getContractDialog.cancelOrder) {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "取消中...";
              done();

              try {
                // const cancelResult = await this.getContractDialog.cancelOrder();

                // if(!cancelResult) {
                //   instance.confirmButtonLoading = false;
                //   return;
                // }

                const result = await this.requestWriteContract(2);

                if (cancelResult && result) {
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "确认取消";

                  this.$message({
                    type: "success",
                    message: "取消成功"
                  });
                  this.handleClose();
                  done();
                }
              } catch (error) {}
            } else {
              console.log(123123123123)
              instance.confirmButtonLoading = false;
              done();
            }
          }
        })
          .then(() => {
            // this.handleClose();
          })
          .catch(() => {});
      } else {
        this.handleClose();
      }
    },

    async handleSubmit() {
      if (this.countdown || this.loading || !this.checked) {
        !this.checked && Message.warning("请同意协议后，再签署合同");
        return;
      }

      this.loading = true;

      try {
        const result = await this.requestWriteContract(1);

        if (result) {
          this.setContractDialog({
            visible: false
          });
          Message.success("合同签署成功");
          if (this.getContractDialog.closeAfter) {
            this.getContractDialog.closeAfter();
          }
        }
      } catch (error) {
        console.log("handleSubmit catch", error);
        error.message && Message.error(error.message);
      } finally {
        this.loading = false;
      }
    },

    startCountdown() {
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1;
        } else {
          clearInterval(this.timer);
        }
      }, 1000);
    }
  }
};
</script>
<style lang="less" scoped>
.confirm-btn {
  &.disabled {
    opacity: 0.6;
  }
}

.custom-footer {
  display: flex;
  align-items: center;
  width: 100%;
}

.agree-bar {
  margin-right: auto;
}

/deep/ .pdf {
  > span {
    border-top: 1px solid #c6c6c6;

    &:first-child {
      border-top: 0 none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ContractAgreementDialog/index.vue